import String from '../../components/locales';

const initialState = {
  setting: null,
  dateMax: [],
  loading: true,
  loadingDate: true,
  error: null,
  status: null,
  statusDate: null,
  language: String,
  loadingLanguage: true,
  menuCollapse: false,
  taskManagerIndicators: {
  	loading: false,
  	status: null,
  	data: null
  }
};

export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/dashboard/initialState.js